import React from 'react';
import ReactDOM from 'react-dom';
import { ExperienceProvider, ContextBuilder } from '@thd-nucleus/experience-context';
import { CustomerProvider } from '@thd-olt-functional/customer-information';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { AppSwitch } from './AppSwitch';
import { getIsInIframe, waitForIdle } from './utils/assistant-utils';

const { experienceContext } = ContextBuilder.client({
  expConfiguration: window?.__EXPERIENCE_PROPS__?.expConfiguration
});

// The loader's stylesheet ships as a non-blocking <link rel="preload"> (see
// postPlugin.js) so it never holds up the host PDP's first paint. Promote it to
// a real stylesheet on demand — AppSwitch calls this once it determines (via the
// reactive isLiveChatUnificationEnabled/excluded-pages config) that the page is
// actually compatible, so incompatible pages never activate it.
function activateStyles() {
  if (typeof document === 'undefined') return;
  document
    .querySelectorAll('link[data-magic-apron-css][rel="preload"]')
    .forEach((link) => link.setAttribute('rel', 'stylesheet'));
}

function renderApp(container) {
  const app = (
    <React.StrictMode>
      <ErrorBoundary name="magic-apron-assistant-loader">
        <ExperienceProvider value={experienceContext}>
          <CustomerProvider>
            <AppSwitch activateStyles={activateStyles} />
          </CustomerProvider>
        </ExperienceProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );

  // React 18/19 uses createRoot instead of render, but we want to maintain compatibility with React 16 for now.
  // It will check for createRoot and use it if available.
  if (typeof ReactDOM.createRoot === 'function') {
    ReactDOM.createRoot(container).render(app);
  } else {
    ReactDOM.render(app, container);
  }
}

if (typeof BroadcastChannel !== 'undefined' && !getIsInIframe()) {
  waitForIdle(() => {
    const container = document.getElementById('magic-apron-loader');
    if (container) {
      renderApp(container);
    }
  });
}
